<template>
  <div>

  </div>
</template>

<script setup name="LinkAbout">
</script>

<style scoped>

</style>